import React, { useState, useEffect, useRef } from "react";
import Header from "../../layout/Header";
import { Tabs, Tab } from "react-bootstrap";
import { backIcon2, profileImage } from "../../../../Image/Index";
import { getDate } from "../../../../utils/helper";
import {
    transactionRedeem,
    customerView,
} from "../../../../components/pages/campaigns/services";
import TransactionViewModal from "./TransactionViewModal";
import { Link, useNavigate, useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import RedeemableModal from "./RedeemableModal";
import RedeemRewardsModal from "./RedeemRewardsModal";
import CustomPagination from "../../partial/CustomPagination";
import { uploadProfileData } from "../../../../actions/auth";
import swal from "sweetalert";

const CustomerView = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const imageInputRef = useRef(null);
    const aadharInputRef = useRef(null);
    const panInputRef = useRef(null)
    const [imagePreview, setImagePreview] = useState(null);
    const [response, setResponse] = useState({});
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState({
        availableValue: "",
        totalAvailableValue: 0,
        totalEarnPoints: "0",
        totalExpiredPoints: "0",
        totalRedeemPoints: "0",
        redeemablePoint: 0,
        walletSummary: [],
        transaction_s: [],
        inputRedeemPoints: "",
        error: "",
        successMsg: "",
        close: false,
        activityLogs: [],
        limit: 5,
        total: 0,
        disable: true,
        profileImg: "",
        aadharImg: "",
        panImg: "",
    });
    const [showLogin, setShowLogin] = useState(false);
    const [redeemModalShow, setRedeemModalShow] = useState(false);
    const [redeemableModalShow, setRedeemableModalShow] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [redeem, setRedeem] = useState({
        customer: {
            customercode: "",
        },
        redeemDetail: {
            walletType: "point",
            values: "",
            transactionType: "redeem",
            transactionDate: "",
        },
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [formData, setFormData] = useState({
        code: "",
        name: "",
        mobile: "",
        contactPerson: "",
        gstNo: "",
        pancard: "",
        userLocation: "",
        mappedData: "",
        distributorCode: "",
        boughtFrom: "",
        feedbackScore: "",
        shopName: "",
        profession: "",
        role: "",
        accessLevel: "",
        status: "",
        aadharCard: "",
        customerType: "",
        customerid: "",
        email: "",
        customer_Code: "",
        cpcustomerstatus: ""
    })

    const {
        code,
        name,
        mobile,
        contactPerson,
        gstNo,
        pancard,
        mappedData,
        userLocation,
        aadharCard,
        distributorCode,
        boughtFrom,
        feedbackScore,
        shopName,
        profession,
        role,
        accessLevel,
        status,
        customerType,
        customerid,
        email,
        customer_Code,
    } = formData

    const {
        availableValue,
        totalAvailableValue,
        totalEarnPoints,
        totalExpiredPoints,
        totalRedeemPoints,
        transaction_s,
        error,
        inputRedeemPoints,
        successMsg,
        activityLogs,
        limit,
        total,
        disable,
        redeemablePoint,
        walletSummary,
        profileImg,
        aadharImg,
        panImg
    } = state;
    const { customer, redeemDetail } = redeem;

    const hiddenKeys = [
        "cpcustomerstatus",
        "cpcustomertype",
        "cpkycstatus",
        "createdAt",
        "createdBy",
        "defaultcard",
        "discriminator",
        "firstvisit",
        "profileImage",
        "id",
        "memberCardNumber",
        "merchantId",
        "referralcode",
        "updatedAt",
        "updatedBy",
        "_attachments",
        "_etag",
        "_rid",
        "_self",
        "_ts"
    ];

    useEffect(() => {
        setLoader(true);
        fetch();
    }, []);

    useEffect(() => {
        setFormData({
            ...formData,
            code: response?.customer?.retailercode || response?.customer?.distributorcode || response?.customer?.customerid || response?.customer?.influencercode || response?.customer?.adminid || "",
            name: response?.customer?.name || "",
            mobile: response?.customer?.mobile || "",
            contactPerson: response?.customer?.contactperson || "",
            gstNo: response?.customer?.gstno || "",
            pancard: response?.customer?.pancard || "",
            userLocation: response?.customer?.location || "",
            mappedData: response?.customer?.mappedretailer || response?.customer?.assigneddistributor || "",
            aadharCard: response?.customer?.aadharcard || "",
            distributorCode: response?.customer?.distributorcode || "",
            boughtFrom: response?.customer?.boughtfrom || "",
            feedbackScore: response?.customer?.feedbackscore || "",
            profession: response?.customer?.profession || "",
            role: response?.customer?.role || "",
            accessLevel: response?.customer?.accesslevel || "",
            status: response?.customer?.status || "",
            shopName: response?.customer?.shopname || "",
            customerType: response?.customer?.customerType || response?.customer?.cpcustomertype || "",
            customerid: response?.customer?.customerid || "",
            email: response?.customer?.email || "",
            customer_Code: response?.customer?.customercode,
            cpcustomerstatus: response?.customer?.cpcustomerstatus
        })
        setState({
            ...state,
            availableValue:
                response?.walletsDetail?.availableValue != null
                    ? response?.walletsDetail?.availableValue
                    : 0,
            totalEarnPoints:
                response?.walletsDetail?.earnedValue != null
                    ? response?.walletsDetail?.earnedValue
                    : 0,
            totalRedeemPoints:
                response?.walletsDetail?.redeemValue != null
                    ? response?.walletsDetail?.redeemValue
                    : 0,
            totalExpiredPoints:
                response?.walletsDetail?.expiredValue != null
                    ? response?.walletsDetail?.expiredValue
                    : 0,
            totalAvailableValue:
                response?.walletsDetail?.TotalavailableValue != null
                    ? response?.walletsDetail?.TotalavailableValue
                    : 0,
            redeemablePoint:
                response?.walletsDetail?.earnedValueRedemptionAfterDate != null
                    ? response?.walletsDetail?.earnedValueRedemptionAfterDate
                    : 0,
            walletSummary: response?.WalletSummary?.filter(
                (wallet) =>
                    getDate(wallet?.redeemableAfterDate, "YYYY-MM-DD") >
                    getDate(new Date(), "YYYY-MM-DD") && wallet
            ),
            transaction_s: response?.transactions ? response?.transactions : [],
            inputRedeemPoints:
                response?.walletsDetail?.TotalavailableValue != null
                    ? response?.walletsDetail?.TotalavailableValue
                    : 0,
            activityLogs: response?.activityLogs
                ? response?.activityLogs.reverse()
                : [],
            total: response?.transactions ? response?.transactions.length : 0,
            profileImg: response?.customer?.profileImage,
            aadharImg: response?.customer?.aadharCardImage,
            panImg: response?.customer?.panCardImage,
        });
        // eslint-disable-next-line
    }, [response]);

    useEffect(() => {
        let tempCustomer_code = customer_Code;
        let tempInputRedeemPoints = parseInt(inputRedeemPoints);
        setRedeem({
            ...redeem,
            customer: { ...customer, customercode: tempCustomer_code },
            redeemDetail: {
                ...redeemDetail,
                values: tempInputRedeemPoints,
                transactionDate: getDate(new Date(), "YYYY-MM-DD"),
            },
        });
    }, [customer_Code, inputRedeemPoints, totalAvailableValue]);

    useEffect(() => {
        if (totalAvailableValue > 0) {
            setState({ ...state, disable: false });
        }
    }, [totalAvailableValue]);
    const path = window.location.pathname;
    const customerPath = path.split("/")[3];

    const fetch = async () => {
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        tempToken = tempToken?.access_token;
        await customerView(tempToken, customerPath)
            .then((res) => {
                setResponse(res);
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    };

    const handleChange = (e, minimumValue) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
        if (e.target.value < minimumValue || totalAvailableValue < e.target.value) {
            if (!e.target.value || e.target.value <= 0) {
                setState({ ...state, error: null, disable: true });
            }
            if (
                (e.target.value || e.target.value > 0) &&
                e.target.value < minimumValue
            )
                setState({
                    ...state,
                    error: `Redeem value must be greater than ${minimumValue - 1}!`,
                    disable: true,
                });
            if (totalAvailableValue < e.target.value)
                setState({
                    ...state,
                    error: `Redeem value must be less than or equal to ${totalAvailableValue} !`,
                    disable: true,
                });
        } else {
            setState({
                ...state,
                [e.target.name]: e.target.value,
                error: null,
                disable: false,
            });
        }
    };
    const handleRedeemApi = async () => {
        if (!error) {
            let tempToken = JSON.parse(localStorage.getItem("token_gen"));
            tempToken = tempToken?.access_token;
            let body = JSON.stringify(redeem);
            setLoader(true);
            let response = await transactionRedeem(tempToken, body);
            await fetch();
            setLoader(false);
            if (response?.message === "Request processed successfully.") {
                setState({ ...state, successMsg: "Redeem points successfully" });
            } else {
                setState({
                    ...state,
                    error: "Your points can't redeem now. Please try later",
                });
            }
        }
    };

    const handleShowModal = (id) => {
        setShowLogin(true);
        setTransactionId(id);
    };

    const displayedArray = activityLogs?.length && activityLogs.slice(0, limit);
    const handleLoadMore = () => {
        setState((prevState) => ({ ...prevState, limit: prevState.limit + 5 }));
    };

    const handleOpenRewardsModal = () => {
        setRedeemModalShow(true);
        setState({ ...state, totalAvailableValue: totalAvailableValue });
    };

    const handleCloseRewardsModal = () => {
        setState({ ...state, successMsg: "", error: "", disable: false });
        setRedeemModalShow(false);
    };

    const openRedeemableModal = () => {
        setRedeemableModalShow(true);
    };

    const closeRedeemableModal = () => {
        setRedeemableModalShow(false);
    };

    const pageSize = 10;
    const pageCount = Math.ceil(total / pageSize);

    const generatePDF = () => {
        const pdf = new jsPDF("p", "mm", "a4");
        pdf.setFontSize(12);
        pdf.setFont("helvetica", "normal");
        const columns = ["Trn ID(last 4 digits)", "Rewards", "Trn Type", "Date"];
        let y = 20;
        columns.forEach((column, index) => {
            pdf.text(column, 10 + index * 40, y);
        });
        y += 10;

        transaction_s.forEach((transaction) => {
            const last4Digits = transaction?.transactionId.slice(-4); // Extract last 4 digits
            const rowData = [
                last4Digits,
                transaction.transactionDetail.transactionType === "redeem"
                    ? transaction.transactionDetail.values +
                    " " +
                    transaction.transactionDetail.walletType
                    : transaction?.qualifiedCampaign?.reduce(
                        (sum, q) => sum + (q.value > 0 ? q.value : 0),
                        0
                    ) +
                    " " +
                    transaction?.qualifiedCampaign?.[0]?.type?.toLowerCase(),
                transaction.transactionDetail.transactionType,
                getDate(transaction.transactionProcessedDate, "DD-MM-YYYY"),
            ];

            rowData.forEach((cell, index) => {
                const xOffset = index === 0 ? 10 : 10 + index * 40;
                pdf.text(String(cell), xOffset, y);
            });
            y += 10;
        });

        pdf.save("report.pdf");
    };

    const generateCSV = () => {
        const data = [["Transaction ID", "Rewards", "Transaction Type", "Date"]];

        transaction_s.forEach((transaction) => {
            const rowData =
                [
                    transaction?.transactionId,
                    transaction.transactionDetail.transactionType === "redeem"
                        ? transaction.transactionDetail.values +
                        " " +
                        transaction.transactionDetail.walletType
                        : transaction?.qualifiedCampaign?.reduce(
                            (sum, q) => sum + (q.value > 0 ? q.value : 0),
                            0
                        ) +
                        " " +
                        transaction?.qualifiedCampaign?.[0]?.type?.toLowerCase(),
                    transaction.transactionDetail.transactionType,
                    getDate(transaction.transactionProcessedDate, "DD-MM-YYYY"),
                ];

            data.push(rowData);
        });

        const csvContent =
            "data:text/csv;charset=utf-8," +
            data.map((row) => row.join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "report.csv");
        document.body.appendChild(link);
        link.click();
    };

    const handleUpdate = () => {
        navigate("/channel-partner/create-user", {
            state: {
                type: customerType,
                formData: formData,
                formType: "edit",
                userData: response?.customer,
                customerType: response?.customer?.customerType || response?.customer?.cpcustomertype
            },
        });
    }
    const handleProfilePic = async (e) => {
        setLoader(true)
        const filedata = e.target.files[0];
        const res = await upload(filedata, "profileImage")
        if (res === "Customer images uploaded and updated successfully.") {
            await fetch()
            swal({
                position: "center",
                icon: "success",
                title: "Profile pic uploaded successfully",
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res,
                showConfirmButton: false,
                timer: 5000,
            });
        }
        setLoader(false)
    };

    const handleAadhar = async (e) => {
        setLoader(true)
        const filedata = e.target.files[0];
        const res = await upload(filedata, "aadharImage")
        if (res === "Customer images uploaded and updated successfully.") {
            await fetch()
            swal({
                position: "center",
                icon: "success",
                title: "Aadhar Card uploaded successfully",
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res,
                showConfirmButton: false,
                timer: 5000,
            });
        }
        setLoader(false)
    };

    const handlePanCard = async (e) => {
        setLoader(true)
        const filedata = e.target.files[0];
        const res = await upload(filedata, "panImage")
        if (res === "Customer images uploaded and updated successfully.") {
            await fetch()
            swal({
                position: "center",
                icon: "success",
                title: "Pan Card uploaded successfully",
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res,
                showConfirmButton: false,
                timer: 5000,
            });
        }
        setLoader(false)
    };

    const upload = async (file, fileName) => {
        let token = JSON.parse(localStorage.getItem("token_gen"));
        try {
            const res = await uploadProfileData(token.access_token, customerPath, file, fileName)
            return res.message
        } catch (err) {
            return err.message
        }
    }

    const getUserClass = (userType) => {
        switch (userType) {
            case 'Distributor':
                return 'distributor';
            case 'Retailer':
                return 'retailer';
            case 'Wholesaler':
                return 'retailer';
            case 'Sales':
                return 'customer';
            case 'CustomerCP':
                return 'customer';
            case 'Influencer':
                return 'influencer';
            default:
                return 'admin';
        }
    }

    const badgeClass = getUserClass(customerType);

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"Customer View"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customerViewMain">
                        <div className="dashboard__heading">
                            <div className="dashboard__headingLeft">
                                <div className="dashboard__headingBackLink">
                                    <Link
                                        to=""
                                        state={{
                                            from:
                                                location?.state?.from === "WalletReport"
                                                    ? "WalletReport"
                                                    : "",
                                        }}
                                        onClick={() => navigate(-1)}
                                    >
                                        <img src={backIcon2} alt="" />
                                        <div className="dashboard__headingContent">
                                            <h3>
                                                {location?.state?.from === "WalletReport"
                                                    ? "Back"
                                                    : "Back to List"}
                                            </h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className={`dashboard_userView ${badgeClass}`}>
                            <div className="dashboard_userView_heading">
                                <h3>Personal Details</h3>
                                <button onClick={() => handleUpdate()}><i className="fa fa-pen-to-square"></i>Edit</button>
                            </div>
                            <div className="dashboard_userView_content">
                                {<div className="dashboard_userView_content_top">
                                    <div className="dashboard_userView_content_top_image">
                                        <div className="dashboard_userView_content_top_image_box">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={imageInputRef}
                                                onChange={handleProfilePic}
                                            />
                                            <div
                                                onClick={() => imageInputRef.current.click()}
                                                style={{
                                                    backgroundImage: profileImg ? `url(${profileImg})` : 'none'
                                                }}
                                                className="dashboard_userView_content_top_image_box_deep"
                                            >
                                                {!profileImg ? (
                                                    <>
                                                        <div className="upload-icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                            </svg>
                                                        </div>
                                                        <span className="upload-text">Click to upload image</span>
                                                    </>
                                                ) : (
                                                    <div className="preview-overlay">
                                                        <span className="edit-text">Click to change</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="dashboard_userView_content_box">
                                    <div className="dashboard_userView_content_box_inner">
                                        <div className="dashboard_userView_content_box_inner_table">
                                            <table className="styled-table">
                                                <tbody>
                                                    {Object.entries(response?.customer || {})
                                                        .filter(([key]) => !hiddenKeys.includes(key))
                                                        .map(([key, value]) => (
                                                            <tr key={key}>
                                                                <td>{location?.state?.schemaData?.[key]?.fielddisplayname || key}</td>

                                                                <td>
                                                                    {Array.isArray(value)
                                                                        ? value.join(", ")
                                                                        : typeof value === "object" && value !== null
                                                                            ? JSON.stringify(value)
                                                                            : String(value)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {(response?.customer?.aadharcard || response?.customer?.pancard) &&
                            <div className="dashboard_userView_others">
                                <div className="dashboard_userView_others_heading">
                                    <h3>Other Details</h3>
                                </div>
                                <div className="dashboard_userView_others_content">
                                    <div className="dashboard_userView_others_content_files">
                                        {response?.customer?.aadharcard && <div className="dashboard_userView_others_content_files_box">
                                            <div className="dashboard_userView_others_content_files_box_inner">
                                                <div className="dashboard_userView_others_content_files_box_inner_heading">
                                                    <h4>Aadhaar Card</h4>
                                                </div>
                                                <div className="upload-container">
                                                    <div className="upload-box" onClick={() => aadharInputRef.current.click()}>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            id="imageUpload"
                                                            onChange={handleAadhar}
                                                            hidden
                                                            ref={aadharInputRef}
                                                        />
                                                        {!aadharImg ? (
                                                            <p>Upload your Aadhaar Card</p>
                                                        ) : (
                                                            <div className="preview-overlay">
                                                                <img src={aadharImg} alt="Preview" className="preview-image" />
                                                                <div className="preview-overlay-change">
                                                                    <span className="edit-text">Click to change</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {response?.customer?.pancard &&
                                            <div className="dashboard_userView_others_content_files_box">
                                                <div className="dashboard_userView_others_content_files_box_inner">
                                                    <div className="dashboard_userView_others_content_files_box_inner_heading">
                                                        <h4>PAN Card</h4>
                                                    </div>
                                                    <div className="upload-container">
                                                        <div className="upload-box" onClick={() => panInputRef.current.click()}>
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                id="imageUpload"
                                                                onChange={handlePanCard}
                                                                hidden
                                                                ref={panInputRef}
                                                            />
                                                            {!panImg ? (
                                                                <p>Upload your Pan Card</p>
                                                            ) : (
                                                                <div className="preview-overlay">
                                                                    <img src={panImg} alt="Preview" className="preview-image" />
                                                                    <div className="preview-overlay-change">
                                                                        <p className="edit-text">Click to change</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="dashboard__customerViewCard">
                            <div className="dashboard__customerViewPointsTabs">
                                <Tabs id="customerViewPointsTabs">
                                    <Tab eventKey="Timeline" title="Timeline">
                                        {Array.isArray(displayedArray) ? (
                                            <div className="dashboard__customerViewTimeline">
                                                {displayedArray?.length &&
                                                    displayedArray?.map((item, i) => (
                                                        <div className="dashboard__customerViewBox" key={i}>
                                                            <span className="timelineIcon active"></span>
                                                            <p>
                                                                {getDate(
                                                                    item.activityDateTime,
                                                                    "YYYY-MM-DD hh:mm:ss"
                                                                )}
                                                            </p>
                                                            <h4>Action :- {item.action}</h4>
                                                            {item.transactionType && (
                                                                <h4>
                                                                    Transaction Type:- {item.transactionType}
                                                                </h4>
                                                            )}
                                                            {item.transactionType == "purchase" &&
                                                                (item.value || !item.voucherCode) ? (
                                                                <h4>Earned:-{item?.value} Points</h4>
                                                            ) : (
                                                                item.voucherCode && (
                                                                    <h4>Earned:- {item.valueType} </h4>
                                                                )
                                                            )}
                                                            {item.transactionType == "redeem" && (
                                                                <h4>Redeem:- {item.value} Points</h4>
                                                            )}
                                                        </div>
                                                    ))}
                                                {limit < activityLogs.length && (
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={handleLoadMore}
                                                    >
                                                        Load More
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <h6 className="text-center">No Record Found</h6>
                                        )}
                                    </Tab>
                                    <Tab
                                        eventKey="Points"
                                        title={"Points"}
                                    >
                                        <div className="dashboard__customerViewPoints">
                                            <div className="row">
                                                <div className="col-lg-10">
                                                    <div className="row gx-2">
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>
                                                                    Available Reward Points
                                                                </h4>
                                                                <h2>{availableValue}</h2>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>Available Reward for Redemption </h4>
                                                                <h2>{totalAvailableValue}</h2>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>Reward Redemption After Date</h4>
                                                                {redeemablePoint > 0 ? (
                                                                    <h2>
                                                                        <span
                                                                            className="totalReward"
                                                                            onClick={openRedeemableModal}
                                                                        >
                                                                            {redeemablePoint}
                                                                            <span className="line">|</span>
                                                                            <i class="fa-solid fa-eye size2"></i>
                                                                        </span>
                                                                    </h2>
                                                                ) : (
                                                                    <h2>{redeemablePoint}</h2>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>
                                                                    Total Earned Points
                                                                </h4>
                                                                <h2>{totalEarnPoints}</h2>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>
                                                                    Total Expired Points
                                                                </h4>
                                                                <h2>{totalExpiredPoints} </h2>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4">
                                                            <div className="dashboard__customerViewBox">
                                                                <h4>
                                                                    Total Redeemed Points
                                                                </h4>
                                                                <h2>{totalRedeemPoints}</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-2">
                                                    <button
                                                        className="btn btn-primary w-100"
                                                        disabled={totalAvailableValue > 0 ? false : true}
                                                        onClick={handleOpenRewardsModal}
                                                    >
                                                        Redeem Rewards
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="Transactions" title="Transactions">
                                        <div
                                            className="dropdown"
                                            style={{
                                                justifyContent: "end",
                                                display: "flex",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <button
                                                className="btn btn-danger dropdown-toggle"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                disabled={transaction_s?.length > 0 ? false : true}
                                            >
                                                Download
                                            </button>
                                            <div
                                                className="dropdown-menu"
                                                aria-labelledby="dropdownMenuButton"
                                            >
                                                <button className="dropdown-item" onClick={generatePDF}>
                                                    Download PDF
                                                </button>
                                                <button className="dropdown-item" onClick={generateCSV}>
                                                    Download CSV
                                                </button>
                                            </div>
                                        </div>
                                        {transaction_s.length > 0 ? (
                                            <div className="table-responsive" id="transaction_Report">
                                                <table className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Transaction ID</th>
                                                            <th>Rewards</th>
                                                            <th>Transaction Type</th>
                                                            <th>Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transaction_s &&
                                                            transaction_s
                                                                .sort((a, b) => {
                                                                    const aDiff = Math.abs(
                                                                        new Date(a.transactionProcessedDate) -
                                                                        new Date()
                                                                    );
                                                                    const bDiff = Math.abs(
                                                                        new Date(b.transactionProcessedDate) -
                                                                        new Date()
                                                                    );
                                                                    return aDiff - bDiff;
                                                                })
                                                                .slice(
                                                                    currentPage * pageSize,
                                                                    (currentPage + 1) * pageSize
                                                                )
                                                                .map((transaction, i) => (
                                                                    <tr key={i}>
                                                                        <td
                                                                            onClick={() =>
                                                                                handleShowModal(
                                                                                    transaction?.transactionId
                                                                                )
                                                                            }
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                color: "#0d6efd",
                                                                            }}
                                                                        >
                                                                            {transaction?.transactionId}
                                                                        </td>
                                                                        <td>
                                                                            {transaction?.transactionDetail
                                                                                ?.transactionType === "redeem"
                                                                                ? (transaction.transactionDetail.values
                                                                                    ? transaction.transactionDetail
                                                                                        .values
                                                                                    : "-") +
                                                                                " " +
                                                                                (transaction.transactionDetail
                                                                                    .walletType
                                                                                    ? transaction.transactionDetail
                                                                                        .walletType
                                                                                    : " ")
                                                                                : transaction?.qualifiedCampaign?.length
                                                                                    ? transaction?.qualifiedCampaign[0]
                                                                                        .type !== "voucher"
                                                                                    && transaction?.qualifiedCampaign?.reduce(
                                                                                        (sum, q) =>
                                                                                            sum +
                                                                                            (q.value > 0 ? q.value : 0),
                                                                                        0
                                                                                    )
                                                                                    :
                                                                                    transaction?.transactionDetail
                                                                                        ?.transactionType === "refund"
                                                                                        ? transaction?.transactionDetail
                                                                                            ?.refundAmount
                                                                                        : transaction?.transactionDetail
                                                                                            ?.transactionType === "reverse"
                                                                                            ? transaction?.transactionDetail
                                                                                                ?.values +
                                                                                            " " +
                                                                                            transaction.transactionDetail
                                                                                                .walletType
                                                                                            : ""}
                                                                        </td>
                                                                        <td>
                                                                            <span
                                                                                style={{
                                                                                    textTransform: "capitalize",
                                                                                }}
                                                                            >
                                                                                {transaction?.transactionDetail
                                                                                    ?.bitType?.length > 0
                                                                                    ? transaction?.transactionDetail
                                                                                        ?.bitType
                                                                                    : transaction?.transactionDetail
                                                                                        ?.transactionType}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            {getDate(
                                                                                transaction.transactionProcessedDate,
                                                                                "DD-MMM-YYYY"
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                    </tbody>
                                                </table>
                                                <div className="dashboard__paginationBox">
                                                    <CustomPagination
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                        pageCount={pageCount}
                                                        value={5}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <h6 className="text-center"> No Record Found</h6>
                                        )}
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {showLogin && (
                <TransactionViewModal
                    show={showLogin}
                    close={() => setShowLogin(false)}
                    transactionId={showLogin && transactionId}
                />
            )
            }

            {
                redeemModalShow && (
                    <RedeemRewardsModal
                        show={redeemModalShow}
                        close={handleCloseRewardsModal}
                        handleRedeemApi={handleRedeemApi}
                        totalAvailableValue={totalAvailableValue}
                        handleChange={handleChange}
                        error={error}
                        successMsg={successMsg}
                        disable={disable}
                    />
                )
            }
            {
                redeemableModalShow && (
                    <RedeemableModal
                        show={redeemableModalShow}
                        close={closeRedeemableModal}
                        walletSummary={walletSummary}
                    />
                )
            }
        </>
    );
};

export default CustomerView;
